import React from 'react';
import { Card, CardContent, Container, Divider, Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Fab from "@material-ui/core/Fab";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import Zoom from "@material-ui/core/Zoom";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { makeStyles } from '@material-ui/styles';
import { useEffect } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { PullToRefresh } from "react-js-pull-to-refresh";
import { connect } from 'react-redux';
import Page from 'src/components/Page';
import { resetDefects } from '../../store/actions/defectActions';
import { resetLabours } from '../../store/actions/labourActions';
import { resetMaterials } from '../../store/actions/materialActions';
import { getTasksRequest } from '../../store/actions/taskActions';
import AtananIsler from './AssignedJob';
import Header from './Header';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  rootScroll: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  },
  statistics: {
    marginTop: theme.spacing(3)
  },
  AtananIsler: {
    marginTop: theme.spacing(1)
  },
  projects: {
    marginTop: theme.spacing(6)
  },
  todos: {
    marginTop: theme.spacing(6)
  },
  content: {
    padding: 0,
    minHeight: 430,
  },
}));


function ScrollTop(props) {
  const { children, window } = props;
  const classes = useStyles();
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 10
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );
    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  return (
    <Zoom in={trigger}>
      <div onClick={handleClick} role="presentation" className={classes.rootScroll}>
        {children}
      </div>
    </Zoom>
  );
}

const Overview = props => {
  const classes = useStyles();
  const { getTasksRequest, resetDefects, resetLabours, resetMaterials, tasks } = props;


  useEffect(() => {
    getTasksRequest();
    resetLabours();
    resetDefects();
    resetMaterials();
  }, [getTasksRequest, resetLabours, resetDefects, resetMaterials]);

 const AtananIslerData = Array.isArray(tasks?.tasks) ? tasks.tasks : [];

  const handleRefresh = () => {
    getTasksRequest();
    resetLabours();
    resetDefects();
    resetMaterials();
  };

  const handleRefreshMain = () => {
    var AlertConfirm = "Merkezdeki işleriniz alınacaktır. Devam etmek istediginizden emin misiniz?";
    confirmAlert({
      message: AlertConfirm,
      buttons: [
        {
          label: 'Evet',
          onClick: () => handleRefreshEvet()
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });
  };

  const handleRefreshEvet = () => {
    getTasksRequest();
    resetLabours();
    resetDefects();
    resetMaterials();
  };
  // removed unused onRefreshEvet



  const onRefresh = () => {
    var AlertConfirm = "Merkezdeki işleriniz alınacaktır. Devam etmek istediginizden emin misiniz?";
    var responseConfirm = window.confirm(AlertConfirm);
    if (responseConfirm === true) {
      try {
        return new Promise((resolve) => {
          setTimeout(resolve, 150);
          getTasksRequest();
        });
      } catch (error) {
        return new Promise((resolve) => {
          setTimeout(resolve, 150);
        });
      }
    } else {
      return new Promise((resolve) => {
        setTimeout(resolve, 150);
      });
    }
  }


  return (
    <Page className={classes.root} title="Artemis Atanan İşler">
      <Container maxWidth="lg">
        <Header AtananIsler={AtananIslerData} handleRefresh={handleRefresh} id="back-to-top-anchor" />
        <PullToRefresh
          pullDownContent={<CircularProgress status={'loading'} style={{ marginLeft: '45%' }} />}
          releaseContent={<CircularProgress status={'loading'} style={{ marginLeft: '45%' }} />}
          refreshContent={<CircularProgress status={'loading'} style={{ marginLeft: '45%' }} />}
          pullDownThreshold={300}
          onRefresh={onRefresh}
          triggerHeight={500}
          startInvisible={true}
        >
          <div style={{ minHeight: 400, textAlign: 'center' }}>
            {(AtananIslerData.length > 0)
              ?
              <AtananIsler className={classes.AtananIsler}
                AtananIsler={AtananIslerData}
                handleRefresh={handleRefresh}
                handleRefreshMain={handleRefreshMain} />
              :
              <div>
                <Divider />
                <Card>
                  <CardContent className={classes.content}>
                    <Typography variant="h5" gutterBottom>
                      <br />
                      <br />
                      Bugün randevulu işiniz bulunmamaktadır!....
                    </Typography>
                  </CardContent>
                </Card>
              </div>
            }

          </div>
          <ScrollTop {...props}>
            <Fab color="secondary" size="small" aria-label="scroll back to top">
              <KeyboardArrowUpIcon />
            </Fab>
          </ScrollTop>
        </PullToRefresh>
      </Container>

    </Page>
  );
}
export default connect(
  state => ({ tasks: state.tasks1 ?? { tasks: [] } })
  ,
  {
    getTasksRequest, resetDefects, resetLabours, resetMaterials
  }
)(Overview);
